import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as CLOSE } from '../../../assets/images/icon_close.svg';
import { Form, Modal } from 'react-bootstrap';
import './Modal.scss';
import styleModal from './ConnectWalletModal.module.scss';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { ImageWithFallback, Search, Select } from '../';
import { saveDepositWalletInfo } from '../../../redux/_actions/persist.action';
import { toast } from 'react-toastify';
import Question from '../../../assets/images/question-mark.svg';
import { useAppDispatch, useAppSelector, useIsLoggedSelector } from '../../../services/hooks.service';
import { InfoContainer } from '../InfoContainer/InfoContainer';
import {
  BLOCKCHAINS,
  BLOCKCHAIN_PROVIDERS,
  PROVIDERS,
  PROVIDER_LOGO,
  PROVIDER_NAME,
  convertChainToSelectList,
  getAvailableWhChainsInfo,
  getEvmChainId,
  isEvmChain,
} from '../../../wallets/providers';
import { useUltradeWallet } from '../../../wallets/useUltradeWallet';
import { EVMConnector } from '../../../wallets/evm/evm.service';
import { ParentAppService } from '../../../services/parrentApp.service';
import { equalsIgnoreCase } from '../../../_utils';
import { checkSolanaWallet } from '../../../wallets/solana/solana.service';
interface SelectWalletModalProps {
  show: boolean;
  onHide: () => void;
  selectedChain?: BLOCKCHAINS | null;
}

export enum WalletType {
  deposit = 'deposit',
  main = 'main',
}

const evmConnector = EVMConnector.getInstance();
const parentAppService = ParentAppService.getInstance();

export const ConnectWalletModal = (props: SelectWalletModalProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const dontShowRef = useRef(null);
  const activeAddress = useAppSelector((state) => state.user.activeAddress);
  const showInfo = useAppSelector((state) => state.persist.showDepositWalletInfo);
  const stateChains = useAppSelector((state) => state.wallet.chains);
  const appTitle = useAppSelector((state) => state.settings.appTitle);
  const isLogged = useIsLoggedSelector();
  const [search, setSearch] = useState('');
  const [blockchainsArray, setBlockchainsArray] = useState([]);
  const [blockchain, setBlockchain] = useState<BLOCKCHAINS>(null);
  const [sellectedChain, setSellectedChain] = useState(false);
  const { connect, switchEvmChain } = useUltradeWallet();
  const [show, setShow] = useState<boolean>(false);
  const [isSolanaWallet, setIsSolanaWallet] = useState<{ phantom: boolean, solflare: boolean, backpack: boolean }>({ phantom: false, solflare: false, backpack: false });

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  useEffect(() => {
    if (parentAppService.checkIfAppEmbedded()) {
      parentAppService.checkSolanaWallet().then(setIsSolanaWallet);
    } else {
      setIsSolanaWallet(checkSolanaWallet());
    }
  }, []);

  const WALLET_TOAST_ID = 'connect';
  const isSolanaMobile = blockchain === BLOCKCHAINS.SOLANA &&
    /Mobile|webOS|BlackBerry|IEMobile|MeeGo|mini|Fennec|Windows Phone|Android|iP(ad|od|hone)/i.test(navigator.userAgent);

  const connectWallet = async (chain: BLOCKCHAINS, providerId: PROVIDERS) => {
    if (evmConnector.chainId && getEvmChainId(chain) && getEvmChainId(chain) !== evmConnector.chainId) {
      await switchEvmChain(chain);
    } else {
      setShow(false);
      const connectedChain = await connect(chain, providerId)
      .then(connChain => {
        if (!equalsIgnoreCase(chain, connChain)) {
          switchEvmChain(chain).then(() => console.log(`Switched from ${connChain} to ${chain}`))
        }
        setShow(true);
        return connChain;
      })
      .catch(e => {
        setShow(true);
        // throw e;
      });
      if (connectedChain) props.onHide();
    }
  } 

  async function connectWalletToasts(chain: BLOCKCHAINS, providerId: PROVIDERS) {
    if(!isEvmChain(chain)) props.onHide();
    toast.loading(t('account_connect.connect_wall'), {
      className: 'custom-toast',
      toastId: WALLET_TOAST_ID,
      closeButton: true,
    });
    await connectWallet(chain, providerId);
    toast.dismiss(WALLET_TOAST_ID);
  }

  const generateInfo = () => {
    return (
      <div className={styleModal.info_connect}>
        {!activeAddress && !isLogged ? (
          <InfoContainer>
            <p> {t('account_connect.first_connect_info')} </p>
          </InfoContainer>
        ) : (
          <>
            {' '}
            {showInfo && (
              <InfoContainer>
                <button className={styleModal.close_info} onClick={() => dispatch(saveDepositWalletInfo(false))}>
                  <CLOSE />
                </button>
                <p> {t('account_connect.deposit_connect_info', {chain: blockchain })} </p>
                <p> {t('account_connect.deposit_connect_info_2')} </p>
                <div className={styleModal.check_cont}>
                  <Form.Check
                    ref={dontShowRef}
                    id='d_s'
                    label={t('account_connect.dont_show')}
                    onChange={() => dispatch(saveDepositWalletInfo(!dontShowRef.current.checked))}
                  />
                </div>
              </InfoContainer>
            )}
          </>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (props.selectedChain) {
      setBlockchain(props.selectedChain);
      setSellectedChain(true);
    }
  }, [props.selectedChain]);

  useEffect(() => {
    const chainsFromStore = getAvailableWhChainsInfo();
    const blockchainArray = (chainsFromStore.length) ? [...chainsFromStore] : [...stateChains];
    setBlockchainsArray(convertChainToSelectList(blockchainArray));
  }, [stateChains.length]);

  const handleBlockchainChange = (chain: BLOCKCHAINS) => {
    setBlockchain(chain);
    if(chain && isEvmChain(chain) && BLOCKCHAIN_PROVIDERS[chain].length === 1) {
      connectWallet(chain, BLOCKCHAIN_PROVIDERS[chain][0])
    }
  }

  return (
    <Modal
      scrollable={true}
      className={classNames(styleModal.connect_wallet_modal, 'nondraggable_card')}
      show={show && props.show}
      // ref={modalRef}
      onHide={() => {
        props.onHide();
      }}
      style={{zIndex: 10}}
    >
      <Modal.Header closeButton>
        <Modal.Title className={styleModal.warning_title}>
          {t('account_connect.connect_wall')}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={styleModal.body}>
          <>
            {generateInfo()}
            <div className={styleModal.wallet_settings}>
              {BLOCKCHAIN_PROVIDERS[blockchain]?.length > 4 && <Search value={search} setValue={setSearch} placeholder={t('account_connect.search_wallet')} />}
              <Select
                current={blockchain || t('account_connect.select_network')}
                selects={blockchainsArray}
                setValue={handleBlockchainChange}
                selected={sellectedChain}
                // addImage={Boolean(blockchain)}
              />
            </div>

            <div className={styleModal.wallet_cont}>
              {/* {isSolanaMobile && <span className={styleModal.message}>{ t("connectWallet.solana_warning", {app: appTitle}) }</span>} */}
              {BLOCKCHAIN_PROVIDERS[blockchain] &&
                BLOCKCHAIN_PROVIDERS[blockchain].map((providerId) => {
                  if ((isSolanaMobile
                    && ((providerId === PROVIDERS.PHANTOM && !isSolanaWallet.phantom)
                    || (providerId === PROVIDERS.SOLFLARE && !isSolanaWallet.solflare)
                    || (providerId === PROVIDERS.BACKPACK && !isSolanaWallet.backpack))
                    || (!isSolanaMobile && providerId === PROVIDERS.MOBILE)
                  )) {
                    return null;
                  }
                  return (
                    <button
                      id={providerId}
                      onClick={() => connectWalletToasts(blockchain, providerId)}
                      className={styleModal.wallet_item}
                      key={providerId}
                  >
                    <ImageWithFallback fallbackSrc={Question} src={PROVIDER_LOGO[providerId]} alt="icon" />
                    <span className={styleModal.wallet_txt}>
                      {providerId === PROVIDERS.METAMASK ? PROVIDER_NAME.WALLET_CONNECT : PROVIDER_NAME[providerId]}
                    </span>
                  </button>
                )
              })}
            </div>
          </>
      </Modal.Body>
    </Modal>
  );
};
